import { render, staticRenderFns } from "./CreateSpending.vue?vue&type=template&id=22fb5ada&"
import script from "./CreateSpending.vue?vue&type=script&lang=js&"
export * from "./CreateSpending.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports